<template>
	<div id="app">
    <div class="toast" v-show='toast.bol'>
      <span>{{toast.text}}</span>
    </div>
		<router-view></router-view>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  created() {},
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(["toast"])
  },
  mounted() {
    var scriptElement = document.createElement('script');
    document.body.appendChild(scriptElement);
    scriptElement.src = "//img.img.9xiu.com/css-js/mobile/js/mobCommon.js?v=202101211885"
  },
  methods: {
  }
};
</script>

<style lang="scss">
  .toast{
    position: fixed;
    top: 45%;
    z-index: 9;
    width: 100%;
    display: flex;
    justify-content: center;
    span{
      background: rgba(0,0,0,.7);
      padding: 10px 30px;
      color: #fff;
      font-size: 28px;
      font-weight: 500;
      border-radius: 10px;
    }
  }
  #app{
    height: 100%;
    box-sizing: border-box;
  }
</style>
